export enum PayInfoView {
  EmployeePays = 0,
  StopPayRequest = 10,
  CancelStopPayRequest = 20
}
